module.exports = __webpack_public_path__ + "static/img/10.8f54051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/10.jpg
// module id = hiiY
// module chunks = 0